import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class OrderstatusService {


  private OrderStatus = {
    status:null,
    
    
  };

  getOrderstatus(){
   
    return this.OrderStatus;
  }
 
  setOrderstatus(Obj){
   this.OrderStatus = Obj;
 
  }

  constructor() { }
}
